// API 配置
// 正式环境
 const API_BASE_URL = 'https://iqc.hitur.com';
//const API_BASE_URL = 'http://localhost:8080';

function getApiUrl(endpoint) {
    return `${API_BASE_URL}${endpoint}`;
}

// 根据类别自动导入Excel文件

export { getApiUrl };
